import { InjectionToken } from '@angular/core'
import { JmlLibConfig } from './jml-lib-config'

export const JML_LIB_CONFIG = new InjectionToken<JmlLibConfig>('JML_LIB_CONFIG')
